import debounce from 'debounce';

export default {
  data() {
    return {
      mixinsrcDebouncedMethodNames: {},
    };
  },
  methods: {
    rcDebounce(func, wait = 300, immediat) {
      if (!this.mixinsrcDebouncedMethodNames[func.name]) {
        // eslint-disable-next-line no-param-reassign
        this.mixinsrcDebouncedMethodNames[func.name] = debounce(func, wait, immediat);
      }
      this.mixinsrcDebouncedMethodNames[func.name]();
    },
  },
};
